module.exports = __webpack_public_path__ + "img/LOGO SEPLAG - AZUL (T) VAZADO.2228a515.svg";